import { render, staticRenderFns } from "./RemindToast.vue?vue&type=template&id=549fd328&scoped=true"
import script from "./RemindToast.vue?vue&type=script&lang=js"
export * from "./RemindToast.vue?vue&type=script&lang=js"
import style0 from "./RemindToast.vue?vue&type=style&index=0&id=549fd328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549fd328",
  null
  
)

export default component.exports